module.exports = __webpack_public_path__ + "img/content6.e55191ea.png";